
if (!customElements.get('calistore-collection-products')) {
customElements.define('calistore-collection-products', class extends HTMLElement {
  connectedCallback() {
    if(this.controller) return;
    this.controller = new AbortController();
    const signal = this.controller.signal;
    const listen = (el, type, fn, options={}) => el.addEventListener(type, fn, {...options,signal});
    const motion = () => matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth';
    const dialog = this.querySelector('dialog'), mount = this.querySelector('.cscol-modal-body');
    const revealCart = async (result, root) => {
      // Finish the native dialog's close/focus restoration before opening Dawn's drawer.
      if (dialog.open) {
        await new Promise(resolve => {
          dialog.addEventListener('close', resolve, {once:true});
          dialog.close();
        });
      }
      try {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') {
          window.location.assign(root+'cart');
          return;
        }
        const sections = result.sections;
        if (!sections?.['cart-drawer'] || !sections?.['cart-icon-bubble']) {
          window.location.assign(root+'cart');
          return;
        }
        drawer.setActiveElement?.(this.opener);
        drawer.classList.remove('is-empty');
        // Dawn refreshes its markup, binds the overlay and opens the drawer itself.
        drawer.renderContents(result);
      } catch {
        // The item is already added: show the cart without sending it again.
        window.location.assign(root+'cart');
      }
    };
    listen(this,'click',event=>{
      const opener=event.target.closest('[data-open]');if(!opener||opener.disabled)return;
      this.opener=opener;const body=document.createElement('div');body.append(opener.closest('article').querySelector('template').content.cloneNode(true));mount.replaceChildren(body);
      const gallery=body.querySelector('.cscol-gallery'), photos=[...gallery.children], count=body.querySelector('[data-photo-count]');
      const galleryUpdate=()=>{const i=Math.round(gallery.scrollLeft/(gallery.clientWidth||1));count.textContent=(i+1)+' / '+photos.length;body.querySelector('[data-photo="-1"]').disabled=i===0;body.querySelector('[data-photo="1"]').disabled=i>=photos.length-1;};
      body.querySelectorAll('[data-photo]').forEach(b=>b.addEventListener('click',()=>gallery.scrollBy({left:Number(b.dataset.photo)*gallery.clientWidth,behavior:motion()})));
      gallery.addEventListener('scroll',galleryUpdate,{passive:true});
      body.querySelector('.cscol-gallery-controls').hidden=photos.length<2;
      const form=body.querySelector('form'), select=form.querySelector('select'), submit=form.querySelector('[type="submit"]');
      const sizes=form.querySelector('.cscol-sizes'), buttons=sizes.querySelector('.cscol-size-buttons'), selected=sizes.querySelector('.cscol-selected'), quantity=form.querySelector('[name="quantity"]');
      form.querySelector('.cscol-select-label').hidden=true;sizes.hidden=false;
      const choices=[...select.options].filter(o=>o.value);
      const refresh=()=>{
        const option=select.selectedOptions[0];submit.disabled=!option?.value||option.disabled;
        submit.textContent=choices.every(o=>o.disabled)?'Agotado':option?.value?'Agregar al carrito':'Elige tu opción';
        [...buttons.children].forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.value===select.value)));
        if(!option?.value)return;
        selected.textContent=option.textContent;
        body.querySelector('[data-price]').textContent=option.dataset.price;
        body.querySelector('[data-compare]').textContent=option.dataset.compare||'';
        const saving=body.querySelector('[data-saving]');saving.hidden=!option.dataset.discount;saving.textContent='−'+option.dataset.discount+'%';
        if(option.dataset.image){const url=new URL(option.dataset.image,location.href);const index=photos.findIndex(p=>p.tagName==='IMG'&&new URL(p.src,location.href).pathname===url.pathname);if(index>=0)gallery.scrollTo({left:index*gallery.clientWidth,behavior:motion()});}
      };
      choices.forEach(option=>{
        const b=document.createElement('button');b.type='button';b.className='cscol-size';b.disabled=option.disabled;b.dataset.value=option.value;b.setAttribute('aria-label',option.textContent);b.title=option.textContent;
        // CaliStore stores COL / USA / EUR / CM / gender together in the variant title.
        const parts=option.textContent.split('|').map(s=>s.trim());
        const col=parts.find(s=>s.includes('COL')), cm=parts.find(s=>/CM/i.test(s)), gender=parts.find(s=>/^(Hombre|Mujer)$/i.test(s));
        const title=document.createElement('strong');title.textContent=col?col.replace(/\s*COL.*$/,''):option.textContent;b.append(title);
        if(cm||gender){const small=document.createElement('small');small.textContent=[cm,gender].filter(Boolean).join(' · ');b.append(small);}
        b.addEventListener('click',()=>{select.value=option.value;refresh();});buttons.append(b);
      });
      if(choices.length===1&&!choices[0].disabled)select.value=choices[0].value;
      refresh();
      const quantityUpdate=()=>form.querySelector('[data-quantity="-1"]').disabled=Number(quantity.value)<=1;
      form.querySelectorAll('[data-quantity]').forEach(b=>b.addEventListener('click',()=>{quantity.value=String(Math.max(1,(Number(quantity.value)||1)+Number(b.dataset.quantity)));quantityUpdate();}));
      quantity.addEventListener('input',quantityUpdate);quantityUpdate();
      form.addEventListener('submit',async event=>{
        event.preventDefault();if(submit.disabled||!form.reportValidity())return;
        const status=form.querySelector('[role="status"]');submit.disabled=true;submit.textContent='Agregando…';status.textContent='';
        const payload=new FormData(form);
        buttons.querySelectorAll('button').forEach(b=>b.disabled=true);
        let uncertain=false;
        try{
          const root=window.Shopify?.routes?.root||'/';
          payload.set('sections','cart-drawer,cart-icon-bubble');
          payload.set('sections_url',window.location.pathname);
          const response=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:payload});
          const result=await response.json();
          if(!response.ok){status.textContent=result.description||'No se pudo agregar el producto. Revisa disponibilidad y cantidad.';return;}
          status.textContent='✓ '+payload.get('quantity')+' × '+body.querySelector('.cscol-modal-title').textContent+' agregado al carrito.';
          form.querySelector('.cscol-cart-link').hidden=false;
          this.dispatchEvent(new CustomEvent('calistore:cart-added',{bubbles:true,detail:result}));
          await revealCart(result,root);
        }catch{uncertain=true;status.textContent='No pudimos confirmar la respuesta. Revisa tu carrito antes de intentarlo de nuevo.';form.querySelector('.cscol-cart-link').hidden=false;}
        finally{[...buttons.children].forEach((b,i)=>b.disabled=choices[i].disabled);refresh();if(uncertain){submit.disabled=true;submit.textContent='Revisa tu carrito';}}
      });
      dialog.showModal();dialog.scrollTop=0;galleryUpdate();
      this.previousOverflow=document.documentElement.style.overflow;document.documentElement.style.overflow='hidden';
    });
    listen(this.querySelector('.cscol-close'),'click',()=>dialog.close());
    listen(dialog,'click',e=>{if(e.target===dialog){const b=dialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)dialog.close();}});
    listen(dialog,'close',()=>{document.documentElement.style.overflow=this.previousOverflow??'';this.opener?.focus();});
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;this.observers?.forEach(o=>o.disconnect());if(this.querySelector('dialog')?.open)document.documentElement.style.overflow=this.previousOverflow??'';}
});
}

